import { PropsWithChildren } from 'react';

import { Box } from '@mui/material';
import clsx from 'clsx';

import styles from './CardsFlexContainer.module.scss';

export const CardsFlexContainer: React.FC<
  PropsWithChildren & { gap?: 'small' | 'normal' | 'large'; containerStyles?: string }
> = ({ children, containerStyles, gap = 'normal' }) => (
  <Box className={clsx(styles.container, styles[`gap-${gap}`], containerStyles)}>{children}</Box>
);
